import { Link } from "react-router-dom";
import { Container } from "./Container";

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-surface-900 text-surface-400">
      <Container>
        <div className="py-16">
          {/* 3-column grid */}
          <div className="grid grid-cols-1 gap-10 sm:grid-cols-3">
            {/* Brand */}
            <div>
              <p className="font-serif font-light text-2xl text-surface-50">
                wp<span className="text-primary-400">→</span>emdash
              </p>
              <p className="mt-3 text-sm text-surface-400 leading-relaxed">
                Precision migration for modern CMS teams.
              </p>
            </div>

            {/* Product */}
            <nav aria-label="Product links">
              <p className="uppercase text-[11px] tracking-[0.2em] font-sans font-medium text-surface-500 mb-4">
                Product
              </p>
              <ul className="flex flex-col gap-3">
                <li>
                  <Link
                    to="/audit"
                    className="text-sm text-surface-400 hover:text-primary-400 transition-colors"
                  >
                    Free Audit
                  </Link>
                </li>
                <li>
                  <a
                    href="#pricing"
                    className="text-sm text-surface-400 hover:text-primary-400 transition-colors"
                  >
                    Pricing
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-sm text-surface-400 hover:text-primary-400 transition-colors"
                  >
                    Documentation
                  </a>
                </li>
              </ul>
            </nav>

            {/* Company */}
            <nav aria-label="Company links">
              <p className="uppercase text-[11px] tracking-[0.2em] font-sans font-medium text-surface-500 mb-4">
                Company
              </p>
              <ul className="flex flex-col gap-3">
                <li>
                  <a
                    href="#"
                    className="text-sm text-surface-400 hover:text-primary-400 transition-colors"
                  >
                    About
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-sm text-surface-400 hover:text-primary-400 transition-colors"
                  >
                    Contact
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          {/* Bottom bar */}
          <div className="mt-8 border-t border-surface-800 pt-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between text-xs text-surface-500">
            <span>&copy; {year} wp→emdash. All rights reserved.</span>
            <span>Built on Cloudflare</span>
          </div>
        </div>
      </Container>
    </footer>
  );
}
